<div soho-busyindicator
     [style.height]="'100%'"
     [text]="' '"
     [blockUI]="true"
     [displayDelay]="0"
     [timeToComplete]="this.uiLoadingIndicatorTimeout"
     [transparentOverlay]="true"
>
    <ng-container *ngIf="isHorizontal; else DisplayAsGrid">
        <lm-horizontal-scroller *ngIf="blockGridOptions && blockGridOptions.data && blockGridOptions.data.length > 0"
            #HorizontalScroller
            [scrollAmount]="640"
            [itemCount]="blockGridOptions.data.length"
        >
            <lm-block-grid *ngIf="blockGridOptions && blockGridOptions.data && blockGridOptions.data.length > 0"
               [showEmptyMessage]="showEmptyMessage"
               [selectionMode]="selectionMode"
               [emptyMessageOptions]="emptyMessage"
               [automationId]="listSpec?.busListSpec?.automationId"
               [display]="'flex'"
               [padding]="'5px 0 5px 0'"
            >
                <ng-container content *ngFor="let data of blockGridOptions.data let i = index">
                    <lm-block-item
                        #LMBlockItem
                        [selected]="data.selected"
                        [blockGridOptions]="blockGridOptions"
                        [data]="data"
                        [populateTooltip]="false"
                        [width]="'320'"
                        [margin]="'0 0 0 15px'"
                        [content]="'sectioned-card'"
                        [isSelectable]="false"
                        [isHorizontal]="true"
                        [automationId]="listSpec?.busListSpec?.automationId"
                        [index]="i"
                        (itemSelected)="onSelected($event)"
                        (itemDoubleClicked)="onDoubleClick($event)"
                    >
                        <ng-container content>
                            <lm-sectioned-card
                                [listSpec]="listSpec"
                                [dataView]="data.dataView"
                                [sectionedCard]="listSpec.busListSpec.sectionedCard"
                                [automationId]="listSpec?.busListSpec?.automationId"
                                [index]="i"
                                (toolbarButtonEvent)="onToolbarButtonEvent($event)"
                                (uiLinkEvent)="onUILinkEvent($event)">
                            </lm-sectioned-card>
                        </ng-container>
                    </lm-block-item>
                </ng-container>
            </lm-block-grid>
        </lm-horizontal-scroller>
    </ng-container>
    <ng-template #DisplayAsGrid>
        <lm-block-grid *ngIf="blockGridOptions && blockGridOptions.data && blockGridOptions.data.length > 0"
           [showEmptyMessage]="showEmptyMessage"
           [selectionMode]="selectionMode"
           [emptyMessageOptions]="emptyMessage"
           [automationId]="listSpec?.busListSpec?.automationId"
        >
            <ng-container content *ngFor="let data of blockGridOptions.data let i = index">
                <lm-block-item
                    #LMBlockItem
                    [selected]="data.selected"
                    [blockGridOptions]="blockGridOptions"
                    [data]="data"
                    [populateTooltip]="false"
                    [width]="'320'"
                    [content]="'sectioned-card'"
                    [isSelectable]="selectionMode && selectionMode !== 'single'"
                    [automationId]="listSpec?.busListSpec?.automationId"
                    [index]="i"
                    (contextMenu)="onContextMenu($event)"
                    (itemActivated)="onItemActivated($event)"
                    (itemSelected)="onSelected($event)"
                    (itemUnSelected)="onUnSelected($event)"
                    (itemDoubleClicked)="onDoubleClick($event)"
                >
                    <ng-container content>
                        <lm-sectioned-card
                            [listSpec]="listSpec"
                            [dataView]="data.dataView"
                            [sectionedCard]="listSpec.busListSpec.sectionedCard"
                            [automationId]="listSpec?.busListSpec?.automationId"
                            [index]="i"
                            (toolbarButtonEvent)="onToolbarButtonEvent($event)"
                            (uiLinkEvent)="onUILinkEvent($event)">
                        </lm-sectioned-card>
                    </ng-container>
                </lm-block-item>
            </ng-container>
            <ng-container pager>
                <div soho-standalone-pager *ngIf="listSpec && !showAsMingleWidget"
                     id="{{testVersion1 ? listSpec.busListSpec.id + '_pager' : null}}"
                     class="scrollable-flex-footer"
                     [attributes]="pagerIdAttributes"
                     [smallPageSizeSelector]="true"
                     [pageSizeMenuSettings]="{ attachToBody: true }"

                     [enableFirstButton]="hasFirstPage"
                     [enablePreviousButton]="hasPreviousPage"
                     [enableNextButton]="hasNextPage"
                     [enableLastButton]="hasLastPage"

                     [firstPageTooltip]="firstPageButtonTooltip"
                     [previousPageTooltip]="previousPageButtonTooltip"
                     [nextPageTooltip]="nextPageButtonTooltip"
                     [lastPageTooltip]="lastPageButtonTooltip"

                     [showPageSizeSelector]="showPageSizeSelector"
                     [pageSize]="pageSize"
                     [pageSizes]="pageSizes"

                     (firstPage)="onFirstPage()"
                     (previousPage)="onPreviousPage()"
                     (nextPage)="onNextPage()"
                     (lastPage)="onLastPage()"
                     (pageSizeChange)="onPageSizeChange($event)"
                ></div>
            </ng-container>
        </lm-block-grid>
    </ng-template>
    <div soho-emptymessage *ngIf="showEmptyMessage"
         style="display:initial"
         [emptyMessageOptions]="emptyMessage"
    ></div>
</div>